import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import {  Message, RestService } from '@stdoutsrl/design-kit';
import { LoaderService } from '../../service/loader.service';

@Component({
  selector: 'app-rules',
  templateUrl: './rules.component.html',
  styles: `
  .plus-add-block{
width: 40px;
padding-left: 20px;
padding-right: 20px;
opacity: 0;
transition-duration: 250ms;
  }
  .plus-add-block:hover{
    width: 100px;
    opacity: 1;
  }
  `,
  standalone: false
})
export class RulesComponent implements OnInit {
  constructor(private router: Router,private message:Message, private rest: RestService, private loader: LoaderService) { }



  ngOnInit(): void {
  }
}
